import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-external-redirect',
  template: '',
})
export class ExternalRedirectComponent implements OnInit {
  constructor(private location: Location) {}
  ngOnInit(): void {
    const token = localStorage.getItem('token'); // Retrieve the token from local storage
    if (token) {
      const externalUrl = `https://adisco-ao.geolane.fr/login?token=${token}`;
     
      //const externalUrl = ` http://localhost:51512/login?token=${token}`
      window.open(externalUrl,'_blank') // Redirect to the external URL
    } else {
      console.error('Token not found in local storage.');
      // Optionally, redirect to an error page or login
    }
    this.location.back(); // Navigate back to the original page
  }
}
